"use client";

import { useEffect } from "react";

export function PostHogProvider({ children }: { children?: React.ReactNode }) {
  useEffect(() => {
    const key = process.env.NEXT_PUBLIC_POSTHOG_KEY;
    // No key configured yet → skip init so local dev / builds don't break.
    if (!key) return;

    const initialize = () => {
      // Load analytics after the initial render and interaction-critical work.
      void import("posthog-js").then((module) => {
        const posthog = module.default;
        if (posthog.__loaded) return;

        posthog.init(key, {
          api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com",
          defaults: "2025-05-24",
          person_profiles: "identified_only",
        });
      });
    };

    const idleWindow = window as Window & {
      requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number;
      cancelIdleCallback?: (id: number) => void;
    };
    if (idleWindow.requestIdleCallback) {
      const id = idleWindow.requestIdleCallback(initialize, { timeout: 2500 });
      return () => idleWindow.cancelIdleCallback?.(id);
    }
    const timer = window.setTimeout(initialize, 1500);
    return () => window.clearTimeout(timer);
  }, []);

  return <>{children}</>;
}
